import React, { useState, useEffect } from 'react'
import { Button, TextField, FormControl, InputLabel, Select, MenuItem, Grid, Switch, TableRow, Typography, Table, TableBody, TableCell, TableContainer, TableHead, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import CircularProgress from '@material-ui/core/CircularProgress'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import plLocale from "date-fns/locale/pl"
import { fetchGetAppLogs, fetchGetAppLogsParams } from '../../../../data'
import { dateConvert } from '../../../../functions'

const LogItem = ({ item, index }) => {
    let dataLogs = Object.entries(JSON.parse(item.data)).filter((entry) => entry[0] !== "TOKEN")

    return (
        <TableRow className='logsTable' style={{background: item.source.includes("DEFAULT")? "#f5f5f5" : "transparent"}}>
            <TableCell>{index + 1}</TableCell>
            <TableCell> {dateConvert(item.date, false).toLocaleString("pl-PL")}</TableCell>
            <TableCell>{item.user_email && item.customer_email? <span>Użytkownik API: {item.user_email}<br />Dokonał: {item.customer_email}</span>: item.user_email? item.user_email : item.customer_email ? item.customer_email : null}</TableCell>
            <TableCell>{dataLogs.length > 4 ?
                <Accordion elevation={0}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        {dataLogs.map((log, i) => i <= 4 ? <React.Fragment>{`${log[0]}: ${log[1]}`} <br /></React.Fragment> : null)}
                    </AccordionSummary>
                    <AccordionDetails>
                        {dataLogs.map((log, i) => i > 4 ? <React.Fragment>{`${log[0]}: ${log[1]}`} <br /></React.Fragment> : null)}
                    </AccordionDetails>
                </Accordion>
                : dataLogs.map((log, i) => dataLogs ? <React.Fragment> {`${log[0]}: ${log[1]}`} <br /></React.Fragment> : <React.Fragment> Brak informacji o zmianach <br /></React.Fragment>)
            }
            </TableCell>
            <TableCell>{item.source}</TableCell>
        </TableRow>
    )
}

const AppLogs = ({ installation }) => {
    const [logs, setLogs] = useState(null)
    const [defaultAppLogs, setDefaultAppLogs] = useState(false)
    const [paramsFilter, setParamsFilter] = useState({ paramsUser: 0, paramsApp: 0, paramsReg: 0, paramsDateFrom: "", paramsDateTo: "" })
    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [info, setInfo] = useState("")

    const handleDefaultAppLogs = (e) => {
        // console.log(e.target.checked)
        setDefaultAppLogs(e.target.checked)
    }

    const getAppLogsParams = (payload) => {
        fetchGetAppLogsParams(payload)
            .then(response => {
                if (response.status === "ok" || response.status === 200) {
                    return response.data
                } else {
                    throw new Error(response.status)
                }
            }).then(response => {
                if (response.items)
                    setLogs(response.items)
                else {
                    setLogs(null)
                    setInfo("Nie ma logów o zadanych parametrach")
                }
            })
            .catch(error => {
                // if (error.message === "403") {
                //     sessionStorage.removeItem("APIToken")
                // }
                setLogs(null)
                setInfo("Nie ma logów o zadanych parametrach")
            })
    }

    const handleParamsLogSend = () => {
        getAppLogsParams(dataPack())
    }

    const dataPack = () => {
        let data = {}
        if (paramsFilter && paramsFilter.paramsUser !== 0)
            data = { ...data, email: paramsFilter.paramsUser }

        if (paramsFilter && paramsFilter.paramsApp !== 0)
            data = { ...data, source: paramsFilter.paramsApp }

        if (paramsFilter && paramsFilter.paramsReg !== 0)
            data = { ...data, param_name: paramsFilter.paramsReg }

        if (paramsFilter && dateFrom !== "0000-00-00" && dateFrom !=="" && dateTo !== "0000-00-00" && dateTo !== "")
            data = { ...data, from: `${dateFrom.toISOString().replace(/T.*/,'')} 00:00:00`, to: `${dateTo.toISOString().replace(/T.*/,'')} 23:59:59` }

        data = {...data, key: installation}
        return data
    }

    const handleChangeParamsFilter = (event) => {
        // console.log(event)
        switch (event.target.name) {
            case "paramsApp":
                setParamsFilter({ ...paramsFilter, paramsApp: event.target.value })
                break;

            case "paramsUser":
                setParamsFilter({ ...paramsFilter, paramsUser: event.target.value })
                break;

            case "paramsReg":
                setParamsFilter({ ...paramsFilter, paramsReg: event.target.value })
                break;

            case "paramsDateFrom":
                if (event.target.value.length === 11) {
                    return
                } else if (event.target.value.length < paramsFilter.paramsDateFrom.length) {
                    setParamsFilter({ ...paramsFilter, paramsDateFrom: event.target.value })
                } else if (event.target.value.length === 4) {
                    setParamsFilter({ ...paramsFilter, paramsDateFrom: event.target.value + "-"})
                } else if (event.target.value.length === 7 || (event.target.value.length === 6 && event.target.value.slice(-1) !== "1" && event.target.value.slice(-1) !== "0")) {
                    setParamsFilter({ ...paramsFilter, paramsDateFrom: event.target.value + "-"})
                } else
                setParamsFilter({ ...paramsFilter, paramsDateFrom: event.target.value })
                break;

            case "paramsDateTo":
                if (event.target.value.length === 11) {
                    return
                } else if (event.target.value.length < paramsFilter.paramsDateTo.length) {
                    setParamsFilter({ ...paramsFilter, paramsDateTo: event.target.value })
                } else if (event.target.value.length === 4) {
                    setParamsFilter({ ...paramsFilter, paramsDateTo: event.target.value + "-"})
                } else if (event.target.value.length === 7 || (event.target.value.length === 6 && event.target.value.slice(-1) !== "1" && event.target.value.slice(-1) !== "0")) {
                    setParamsFilter({ ...paramsFilter, paramsDateTo: event.target.value + "-"})
                } else
                setParamsFilter({ ...paramsFilter, paramsDateTo: event.target.value })
                break;;

            default:
                break;
        }
    }

const getAppLogs = (filters) => {
    if(filters && filters === "reset"){
        setParamsFilter({ paramsUser: 0, paramsApp: 0, paramsReg: 0, paramsDateFrom: "", paramsDateTo: "" })
        setDateFrom(new Date())
        setDateTo(new Date())
    }
    fetchGetAppLogs(installation).then(res => {
        if (res.status === "ok" || res.status === 200){
            setDateFrom(new Date(res.data.items[res.data.items.length - 1].date))
            setDateTo(new Date(res.data.items[0].date))
            return setLogs(res.data.items)
        }else{
            setInfo("Nie ma logów o zadanych parametrach")
            return setLogs(null)
        }
    }
    )
}
    useEffect(() => {
        let mounted = true
        getAppLogs()
        return () => {
            mounted = false
        }
    }, [installation])


    return (
        <React.Fragment>
        <Grid container>
                <Grid item xs={2}>
                    <FormControl style={{ margin: "20px -15px" }}>
                        {/*<InputLabel id="paramsUser">Użytkownik</InputLabel>
                         ---------- input do wpisywania ---------- */}
                        <TextField
                            labelId="paramsUser"
                            name="paramsUser"
                            id="paramsUserId"
                            label="Użytkownik"
                            value={paramsFilter && paramsFilter.paramsUser ? paramsFilter.paramsUser : ""}
                            placeholder="Email"
                            onChange={handleChangeParamsFilter}
                        />
                            {/*<MenuItem value={0}>Użytkownik</MenuItem>
                            Object.entries(paramsService.serviceNoteStatus).map(item => {
                                return <MenuItem key={item[1]} value={item[0]}> {item[1]} </MenuItem>
                            })
                       
                        </Select> */}
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <FormControl style={{ margin: "20px -15px" }}>
                        <InputLabel id="paramsApp">Aplikacja</InputLabel>
                        <Select
                            labelId="paramsApp"
                            name="paramsApp"
                            id="paramsAppId"
                            value={paramsFilter && paramsFilter.paramsApp ? paramsFilter.paramsApp : 0}
                            onChange={handleChangeParamsFilter}
                        >
                            <MenuItem value={0}>Wybierz</MenuItem>
                            <MenuItem value={"EurosBox"}>Euros Box </MenuItem>
                            <MenuItem value={"EurosSerwis"}>Euros Serwis </MenuItem>
                            <MenuItem value={"Rejestry"}>Rejestry </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <FormControl style={{ margin: "20px -15px" }}>
                        {/*<InputLabel id="paramsReg">Rejestr</InputLabel>
                         ---------- input do wpisywania ---------- */}
                        <TextField
                            labelId="paramsReg"
                            name="paramsReg"
                            id="paramsRegId"
                            label="Rejestr"
                            value={paramsFilter && paramsFilter.paramsReg ? paramsFilter.paramsReg : ""}
                            placeholder="Nazwa"
                            onChange={handleChangeParamsFilter}
                        />
                       {/* <Select
                            labelId="paramsReg"
                            name="paramsReg"
                            id="paramsRegId"
                            value={paramsFilter && paramsFilter.paramsReg ? paramsFilter.paramsReg : 0}
                            onChange={handleChangeParamsFilter}
                        >
                            <MenuItem value={0}>Wybierz</MenuItem>
                            Object.entries(paramsService.serviceNoteMethod).map(item => {
                                return <MenuItem key={item[1]} value={item[0]}> {item[1]} </MenuItem>
                            })
                        
                        </Select>*/}
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <FormControl style={{ margin: "20px -15px" }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
                            <KeyboardDatePicker
                                variant="inline"
                                ampm={false}
                                label="Od dnia"
                                placeholder="0000-00-00"
                                value={dateFrom}
                                onChange={setDateFrom}
                                format="yyyy-MM-dd"
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <FormControl style={{ margin: "20px -15px" }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
                            <KeyboardDatePicker
                                variant="inline"
                                ampm={false}
                                label="Do dnia"
                                placeholder="0000-00-00"
                                value={dateTo}
                                onChange={setDateTo}
                                format="yyyy-MM-dd"
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                        </Grid>
                <Grid item xs={1}>
                    <Button variant="contained" color="primary" onClick={() => handleParamsLogSend()} style={{ marginTop: '30px', float: "right" }}>Zobacz</Button>
                </Grid>
                <Grid item xs={1}>
                    <Button variant="contained" color="primary" onClick={() => getAppLogs("reset")} style={{ marginTop: '30px', float: "right" }}>Reset</Button>
                </Grid>
            </Grid>
            <Grid container>
            <Grid item xs={8}></Grid>
                <Grid item xs={3}><Typography variant="body2">Logi z ustawienia wartości domyślnych</Typography></Grid>
                <Grid item xs={1}>
                    <Switch
                        checked={defaultAppLogs}
                        onChange={handleDefaultAppLogs}
                        color="primary"
                        name="checkedB"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </Grid>
            </Grid>
            {logs? <TableContainer>
                <Table aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Typography component="div" height="100%">LP</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography component="div" height="100%">Data</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography component="div" height="100%">Użytkownik</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography component="div" height="100%">Zmiana</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography component="div" height="100%">Aplikacja</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {logs ? logs.map((item, index) => defaultAppLogs? <LogItem item={item} index={index} key={index} /> : !item.source.includes("DEFAULT") ? <LogItem item={item} index={index} key={index} /> : null) : null}
                    </TableBody>
                </Table>
            </TableContainer> : info !== "" ? <Typography variant="h3" style={{ textAlign: "center", marginBottom: "30px" }}>{info}</Typography> : <CircularProgress />}
        </React.Fragment>
    )

}

export default AppLogs